import {
  BRAND_LINKS,
  SUPPORT_EMAIL,
  SUPPORT_WHATSAPP_DISPLAY,
} from "@tami/core";
import type { CopyShape } from "@tami/core/intl";

import {
  PRIVACY_POLICY_DOCUMENT,
  TERMS_OF_USE_DOCUMENT,
  legalDocumentPath,
} from "@/lib/legal/legal-documents";

import type { BIO_COPY_PT_BR } from "../bio-site.copy";

// `DEMO_BASE_HREF` não vem de `../bio-site.copy`: o import seria circular (o
// copy em português importa este arquivo). O destino é o mesmo, "/demo".
const DEMO_BASE_HREF = "/demo";

export const BIO_COPY_EN_US: CopyShape<typeof BIO_COPY_PT_BR> = {
  tagline: {
    before: "The tool that ",
    highlight: "organizes",
    after: " your creator life.",
  },
  social: [
    { key: "instagram", ...BRAND_LINKS.instagram },
    { key: "youtube", ...BRAND_LINKS.youtube },
  ],
  cta: {
    label: "Create my account",
    description: "Free to start",
    href: BRAND_LINKS.signUp.href,
  },
  links: [
    {
      key: "demo",
      label: "See Tãmi in action",
      description: "A product tour, no account needed",
      href: DEMO_BASE_HREF,
      external: false,
    },
    {
      key: "pricing",
      label: "Plans and pricing",
      description: undefined,
      href: "/en#pricing",
      external: false,
    },
    {
      key: "site",
      label: "Discover Tãmi",
      description: undefined,
      href: BRAND_LINKS.site.href,
      external: false,
    },
  ],
  features: [
    { key: "agenda", label: "Calendar" },
    { key: "conteudo", label: "Content" },
    { key: "campanhas", label: "Campaigns" },
    { key: "financas", label: "Finances" },
    { key: "whatsapp", label: "WhatsApp" },
  ],
  collab: {
    title: "Managing several creators?",
    description: {
      before: "In Collab mode, one account takes care of ",
      highlight: "all",
      after:
        " your roster's creators: each one's schedule, campaigns, and finances, in one place.",
    },
    ctaLabel: "Talk to us",
  },
  support: {
    title: "Need help?",
    whatsappLabel: SUPPORT_WHATSAPP_DISPLAY,
    whatsappHref: BRAND_LINKS.supportWhatsApp.href,
    emailLabel: SUPPORT_EMAIL,
    emailHref: BRAND_LINKS.supportEmail.href,
  },
  footer: {
    terms: { label: "Terms of use", href: legalDocumentPath(TERMS_OF_USE_DOCUMENT, "en-US") },
    privacy: {
      label: "Privacy policy",
      href: legalDocumentPath(PRIVACY_POLICY_DOCUMENT, "en-US"),
    },
  },
};
